module.exports = __webpack_public_path__ + "img/main-logo.42393f22.png";